import React from 'react';
import { FadeIn } from './FadeIn';
import { Maximize2, Eclipse, Smartphone, Hourglass } from 'lucide-react';
export function AgitationSection() {
  const mistakes = [{
    icon: <Maximize2 className="w-5 h-5 text-brand-red" strokeWidth={1.8} data-id="element-14" />,
    problem: 'Comprar ropa 2 tallas más grande',
    explanation: 'Solo elimina tu forma natural y te hace ver como un bloque sin silueta'
  }, {
    icon: <Eclipse className="w-5 h-5 text-brand-red" strokeWidth={1.8} data-id="element-15" />,
    problem: 'Usar negro de pies a cabeza sin estructura',
    explanation: 'Sin proporción correcta, el negro solo crea una mancha oscura sin elegancia'
  }, {
    icon: <Smartphone className="w-5 h-5 text-brand-red" strokeWidth={1.8} data-id="element-16" />,
    problem: 'Seguir tendencias de TikTok para adolescentes',
    explanation: 'Esos cortes no consideran las proporciones reales de una mujer adulta'
  }, {
    icon: <Hourglass className="w-5 h-5 text-brand-red" strokeWidth={1.8} data-id="element-17" />,
    problem: 'Esperar a bajar de peso para vestirte bien',
    explanation: 'Cada día que esperas es un día que pierdes confianza y oportunidades'
  }];
  return <section className="bg-white py-10 sm:py-16 px-4" data-id="element-18">
      <div className="max-w-content mx-auto" data-id="element-19">
        <FadeIn data-id="element-20">
          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center text-brand-text mb-10" data-id="element-21">
            Por qué todo lo que intentaste antes no funcionó
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-12" data-id="element-22">
          {mistakes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-23">
              <div className="flex items-start gap-4 p-4 rounded-lg hover:bg-brand-bg transition-colors" data-id="element-24">
                <div className="flex-shrink-0 mt-1" data-id="element-25">
                  <div className="bg-brand-red/10 p-2.5 rounded-full" data-id="element-26">
                    {item.icon}
                  </div>
                </div>
                <div data-id="element-27">
                  <h3 className="font-bold text-brand-text text-lg mb-1" data-id="element-28">
                    {item.problem}
                  </h3>
                  <p className="text-brand-text/80 leading-relaxed" data-id="element-29">
                    → {item.explanation}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-30">
          <div className="text-center px-4" data-id="element-31">
            <p className="text-xl sm:text-2xl font-serif italic text-brand-accent max-w-lg mx-auto leading-relaxed" data-id="element-32">
              "La mujer que se viste con intención no espera a tener el cuerpo
              perfecto. Ya lo tiene."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}